// @flow
import React, { Fragment } from "react";

import { GlobalProvider } from "../common/GlobalContext";
import GlobalAlert from "../common/GlobalAlert";
import Calculator from "../common/Calculator";

import type { $History, $ReactRouter } from "flow/types";

type $Props = {
  alerts: Object,
  globalGA: string,
  location: $ReactRouter,
  path: string,
  siteUser: Object,
  theme: Object, // theme from the API/site settings, not the react-jss theme
  history: $History,
};

const MortgageCalculator = ({ alerts, siteUser, theme }: $Props) => (
  <GlobalProvider siteUser={siteUser} theme={theme}>
    <Fragment>
      <GlobalAlert alerts={alerts} />
      <div style={{ margin: "60px auto", maxWidth: "800px" }}>
        <Calculator />
      </div>
    </Fragment>
  </GlobalProvider>
);

export default MortgageCalculator;
